import { useContext } from 'react';
import { GenerateInvoiceXslJobContext } from './context';

export default function useGenerateInvoiceXslJobContext() {
  return useContext(GenerateInvoiceXslJobContext);
}
